import { Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RightMenuProvider } from "./components/Layout"; // circular dependency when imported earlier
import { AuthProvider } from "./features/Authorization/AuthProvider";
import { GamificationProvider } from "./features/Gamification/GamificationProvider";
import { GlobalLoader } from "./features/GlobalLoader/GlobalLoader";
import { I18nProvider, TLIntlProvider } from "./features/I18n/I18nProvider";
import {
  ConfirmModal,
  ModalCtx,
  SnackbarCtx,
  StackProvider,
  TLSnackbar,
  mapModalExtraProps,
} from "./features/Modal/ConfirmModal";
import { VisualEffectsProvider } from "./features/VisualEffects/VisualEffectsProvider";
import "./index.css";
import theme from "./theme";

const queryClient = new QueryClient();
if (!window._queryClient) window._queryClient = queryClient;

export const Contexts = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <VisualEffectsProvider>
        <TLIntlProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <GlobalLoader>
                <StackProvider
                  logAs="SnackbarProvider"
                  Ctx={SnackbarCtx}
                  Provider={SnackbarCtx.Provider}
                  ItemComponent={TLSnackbar}
                >
                  <I18nProvider>
                    <StackProvider
                      logAs="ModalProvider"
                      Ctx={ModalCtx}
                      Provider={ModalCtx.Provider}
                      ItemComponent={ConfirmModal}
                      mapExtraProps={mapModalExtraProps}
                    >
                      <GamificationProvider>
                        <RightMenuProvider>
                          <CssBaseline />
                          {children}
                        </RightMenuProvider>
                      </GamificationProvider>
                    </StackProvider>
                  </I18nProvider>
                </StackProvider>
              </GlobalLoader>
            </AuthProvider>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 0,
                height: 0,
              }}
            >
              <ReactQueryDevtools initialIsOpen={false} />
            </Box>
          </QueryClientProvider>
        </TLIntlProvider>
      </VisualEffectsProvider>
    </ThemeProvider>
  );
};
